import { NgModule } from '@angular/core';
import { DxPieChartModule } from 'devextreme-angular';
import { DxTreeListModule } from 'devextreme-angular';
import { DxDataGridModule } from 'devextreme-angular';
import { DxTreeViewModule } from 'devextreme-angular';
import { DxTagBoxModule } from 'devextreme-angular';
import { DxLoadPanelModule } from 'devextreme-angular';
import { DxSliderModule } from 'devextreme-angular';
import { DxNumberBoxModule } from 'devextreme-angular';

const modules = [
  DxPieChartModule,
  DxTreeListModule,
  DxDataGridModule,
  DxTreeViewModule,
  DxTagBoxModule,
  DxLoadPanelModule,
  DxSliderModule,
  DxNumberBoxModule
];

@NgModule({
  imports: modules,
  exports: modules,
})
export class DevExtremeModule {}
